<div class="plans-wrapper">
    <div class="plans-wrapper-heading d-flex align-items-center justify-content-between flex-wrap gap-2">
        <div *ngIf="!hasTrialExpired">Start accepting real customer calls.</div>
        <div *ngIf="hasTrialExpired">Activate 3-day Trial Extension</div>
        <img src="assets/images/credit-cards.png" class="credit-cards-image" [ngClass]="{'d-none': isMobileVersion}">
    </div>
    <div class="d-flex align-items-center flex-wrap plans-wrapper-description-wrapper">
        <div class="plans-wrapper-description">
            <ng-icon class="tiny-success-icon" [name]="'heroCheckCircle'" [color]="'#047857'" [size]="'16px'"
                [strokeWidth]="'2px'"></ng-icon>
            <span><b>Free until trial ends.</b> Cancel anytime.</span>
        </div>
        <div class="plans-wrapper-description">
            <ng-icon class="tiny-success-icon" [name]="'heroCheckCircle'" [color]="'#047857'" [size]="'16px'"
                [strokeWidth]="'2px'"></ng-icon>
            <span>Trusted by <b>1,900+</b> businesses.</span>
        </div>
        <div class="plans-wrapper-description">
            <ng-icon class="tiny-success-icon" [name]="'heroCheckCircle'" [color]="'#047857'" [size]="'16px'"
                [strokeWidth]="'2px'"></ng-icon>
            <span>Secure checkout powered by Stripe</span>
        </div>
    </div>
    <img src="assets/images/credit-cards.png" class="credit-cards-image" [ngClass]="{'d-none': !isMobileVersion}">

    <div class="plans-selection-wrapper">
        <div class="plans-selection-heading" *ngIf="!isOnLegacyUnlimitedMinutes">Select a plan:</div>
        <rosie-subscription-plans-checkout [isOnboardingLayout]="true"
            [hideIntervalToggle]="false"></rosie-subscription-plans-checkout>
    </div>
</div>
<div class="section launch what-next">
    <div class="setup-heading">
        <span>What happens next?</span>
    </div>
    <div class="setup-content first">
        <div class="setup-item mb-0 d-flex align-items-start justify-content-center justify-content-md-between">
            <div class="d-flex align-items-center">
                <ng-icon class="icon" [name]="'heroCursorArrowRays'" [color]="'#822AC6'"></ng-icon>
                <div class="setup-labels-wrapper">
                    <div class="setup-item-label long d-flex align-items-center">
                        <span>Select the plan that's right for you above. <b>You will not be charged until
                                your trial ends.</b></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="setup-content">
        <div class="setup-item mb-0 d-flex align-items-start justify-content-center justify-content-md-between">
            <div class="d-flex align-items-center">
                <ng-icon class="icon" [name]="'heroCreditCard'" [color]="'#822AC6'"></ng-icon>
                <div class="setup-labels-wrapper">
                    <div class="setup-item-label long d-flex align-items-center">
                        <span *ngIf="!hasTrialExpired">Enter your credit card to allow Rosie to start
                            accepting live calls</span>
                        <span *ngIf="hasTrialExpired">Enter your credit card to regain access to
                            Rosie.</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="setup-content last responsive-item">
        <div class="setup-item mb-0 d-flex align-items-start justify-content-center justify-content-md-between">
            <div class="d-flex align-items-center">
                <ng-icon class="icon" [name]="'heroPhoneArrowUpRight'" [color]="'#822AC6'"></ng-icon>
                <div class="setup-labels-wrapper">
                    <div class="setup-item-label long d-flex align-items-center">
                        <span>Have Rosie answer your calls by forwarding to or directly using your Rosie
                            number. Want to learn more?
                            <span class="launch-instructions-link" (click)="navigateToLaunchInstructions()">Check out
                                our full launch
                                instructions</span>.</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>